import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Initialize feature flags system
import './util/featureFlags';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
